import { useNavigate, useSearchParams } from 'react-router-dom'
import { useVenues } from '../../hooks/useVenues'
import { VenuesTable } from '../../components/VenuesTable/VenuesTable'
import { ListFilterBar } from '../../components/ListFilterBar/ListFilterBar'
import { ListEntityPage } from '../ListEntityPage/ListEntityPage'
import { buildListFiltersSearchParams } from '../helpers/buildListFiltersSearchParams'
import { matchesVenueFilters } from '../helpers/matchesVenueFilters'
import { readListFiltersFromParams } from '../helpers/readListFiltersFromParams'
import { VENUES_FILTER_FIELDS } from '../venueListFilterFields'

export function VenuesPage() {
  const { venues, isLoading, error } = useVenues()
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const filters = readListFiltersFromParams(searchParams, VENUES_FILTER_FIELDS)
  const filteredVenues = venues.filter((venue) =>
    matchesVenueFilters(
      venue.id,
      venue,
      filters.venue ?? '',
      filters.venueType ?? ''
    )
  )

  return (
    <ListEntityPage
      title="Venues"
      loadingLabel="venues"
      isLoading={isLoading}
      error={error}
      createHref="/venues/create"
      createLabel="New venue"
    >
      <ListFilterBar
        fields={VENUES_FILTER_FIELDS}
        initialValues={filters}
        onChange={(next) =>
          setSearchParams(
            buildListFiltersSearchParams(
              searchParams,
              VENUES_FILTER_FIELDS,
              next
            )
          )
        }
      />
      <VenuesTable
        venues={filteredVenues}
        onRowClick={(v) => navigate(`/venues/${v.id}`)}
      />
    </ListEntityPage>
  )
}
